"use client";
import { useRouter, useSearchParams } from "next/navigation";
import { useTransition } from "react";

export const useUpdateSearchParameters = () => {
  const router = useRouter();
  const searchParameters = useSearchParams();
  const [isPending, startTransition] = useTransition();

  const updateParameters = (params, route) => {
    const current = new URLSearchParams(searchParameters.toString());

    const updates = Array.isArray(params) ? params : [params];

    for (const { key, value } of updates) {
      if (value === undefined || value === "") {
        current.delete(key);
      } else {
        current.set(key, value);
      }
    }

    const newQuery = current.toString();
    startTransition(() => {
      router.push(`${route ?? ""}?${newQuery}`, { scroll: false });
      router.refresh();
    });
  };

  const clearParameters = () => {
    startTransition(() => {
      router.push(window.location.pathname, { scroll: false });
      router.refresh();
    });
  };

  return {
    updateParams: updateParameters,
    clearParams: clearParameters,
    isLoading: isPending,
  };
};
